export const GO_TO_ITEMS_DISPLAY_PAGE = 'GO_TO_ITEMS_DISPLAY_PAGE' as const;
export const GO_TO_ITEM_SELECTION_PAGE = 'GO_TO_ITEM_SELECTION_PAGE' as const;
export const SET_OWNERSHIP_STATUS = 'SET_OWNERSHIP_STATUS' as const;
export const SET_PYC_GAME_ITEMS = 'SET_PYC_GAME_ITEMS' as const;
export const SET_SELECTED_GAME_ITEM_ID = 'SET_SELECTED_GAME_ITEM_ID' as const;
export const SET_ADDITIONAL_DETAILS_STATUS = 'SET_ADDITIONAL_DETAILS_STATUS' as const;

export const PYC_REDEMPTION_ENDPOINT = '/redeem-select-item/public/v1/user-products';

export const MAX_GAMES_AMOUNT = 10;
export const SELECTED_ITEM_KEY = 'selectedItem';

export enum ADDITIONAL_DETAILS_STATUS {
    COMPLETED = 'COMPLETED',
    NOT_COMPLETED = 'NOT_COMPLETED'
}

export enum OWNERSHIP_STATUS {
    OWNED_ALL_GAMES = 'OWNED_ALL_GAMES',
    OWNED_NOT_ALL_GAMES = 'OWNED_NOT_ALL_GAMES'
}

export enum IUPCProductType {
    GAME = 0,
    ADDON = 1,
    PACKAGE = 5,
    CONSUMABLE = 8,
    CONSUMABLE_PACK = 10,
    BUNDLE= 11
}

export enum IUPCProductOwnership  {
    OWNED = 0,
    PRE_ORDERED = 1,
    REVOKED = 3,
    SUSPENDED = 4,
    LOCKED = 5
}
